import { gql } from '@/__generated__/gql';

export const LIST_INVESTMENT_ENTITY_INTERESTS_QUERY = gql(`
  query FatSeekingInterestPageListInvestmentEntityInterests($data: InvestmentEntityListDto!) {
    listInvestmentEntityInterests(data: $data) {
      total
      page
      perPage
      lastPage
      data {
        id
        entityName
        overallCapacity
        assetClassCapacity
        suitability
        totalEntityValue
        biteSize
        fundBiteSize
        directBiteSize
        alwaysShow
        taxExempt
        ignoreAllocationTargets
        ignoreBiteSize
        groupId
        tenant {
          name
        }
        family {
          id
          name
        }
        advisor {
          firstName
          lastName
          initials
        }
        suitabilityCriteria {
          label
          value
        }
        investor_interest {
          id
          amount
          legal_entity {
            id
            entityName
          }
        }
      }
    }
  }
`);

export const INVESTMENT_QUERY = gql(`
  query FatSeekingInterestPageInvestment($id: String!) {
    Investment(id: $id) {
      id
      symbol
      name
      type
      managerId
      custodied
      NAV
      distributionsToDate
      assetClass {
        id
        name
      }
      subAssetClass {
        id
        name
      }
      pacingType
      pacingStartingYear
      sectors
      averageCalledPercent
      countOfInvestors
      committedCapital
      economicExposure
      targetReturn
      targetYield
      vintageYear
      nextClose
      finalClose
      investorDocsDue
      minimum
      sri
      ubtiBlocker
      capitalCalled
      unfundedCommitments
      subAssetClasses
      tags
      description
      securityStatus
      investmentOwner {
        firstName
        lastName
        email
      }
      operationsOwner {
        firstName
        lastName
        email
      }
      complianceOwner {
        firstName
        lastName
        email
      }
      offeringMaterialsDescription
      offeringMaterialsAttachments {
        id
        asset {
          url
          assetKey
        }
        visibility
      }
      workflowInstance {
        id
        currentState {
          name
          label
        }
      }
    }
  }
`);

export const INVESTMENTS_BY_WORKFLOW_STATE_MIN_QUERY = gql(`
  query FatSeekingInterestPageInvestmentsByWorkflowState($data: InvestmentsByWorkflowStateInput!) {
    InvestmentsByWorkflowState(data: $data) {
      total
      page
      perPage
      data {
        investment {
          id
        }
        investorInterests {
          id
          amount
          legal_entity {
            id
            entityName
          }
        }
      }
    }
  }
`);
